// Test IDs for the admin panel (Story 2.5). Values kebab-case per ./auth.js.

export const ADMIN = {
  page: 'admin-page',
  search: 'admin-search-input',
  statusFilter: 'admin-status-filter',
  funnelSignups: 'admin-funnel-signups',
  funnelOnboarding: 'admin-funnel-onboarding',
  funnelAvatars: 'admin-funnel-avatars',
  funnelArtifacts: 'admin-funnel-artifacts',
  userRow: 'admin-user-row',
  accessSwitch: 'admin-access-switch',
  planSelect: 'admin-plan-select',
  confirmDialog: 'admin-confirm-dialog',
  confirmAction: 'admin-confirm-action',
  prevPage: 'admin-prev-page',
  nextPage: 'admin-next-page',
  pwaInstalled: 'admin-pwa-installed',
  pwaAccepted: 'admin-pwa-accepted',
  pwaSubs: 'admin-pwa-subs',
  pwaSent: 'admin-pwa-sent',
  personaBadge: 'admin-persona-badge', // suffixed with -<id>
  personaReset: 'admin-persona-reset', // suffixed with -<id>
  personaResetDialog: 'admin-persona-reset-dialog',
  personaResetContinue: 'admin-persona-reset-continue',
  personaResetCancel: 'admin-persona-reset-cancel',
  personaResetInput: 'admin-persona-reset-input',
  personaResetConfirm: 'admin-persona-reset-confirm',
  create: 'admin-create-user',
  createDialog: 'admin-create-dialog',
  createName: 'admin-create-name',
  createEmail: 'admin-create-email',
  createPassword: 'admin-create-password',
  createPlan: 'admin-create-plan',
  createAccess: 'admin-create-access',
  createSubmit: 'admin-create-submit',
  details: 'admin-user-details',
  detailDialog: 'admin-detail-dialog',
  detailName: 'admin-detail-name',
  detailEmail: 'admin-detail-email',
  detailPlan: 'admin-detail-plan',
  detailAccess: 'admin-detail-access',
  detailSave: 'admin-detail-save',
  detailHistory: 'admin-detail-history',
  password: 'admin-set-password',
  passwordDialog: 'admin-password-dialog',
  passwordInput: 'admin-password-input',
  passwordConfirm: 'admin-password-confirm',
  revokeSessions: 'admin-revoke-sessions',
  revokeDialog: 'admin-revoke-dialog',
  revokeConfirm: 'admin-revoke-confirm',
  impersonate: 'admin-impersonate',
  impersonateDialog: 'admin-impersonate-dialog',
  impersonateConfirm: 'admin-impersonate-confirm',
  impersonationBanner: 'admin-impersonation-banner',
  impersonationReturn: 'admin-impersonation-return',
  detailClose: 'admin-detail-close',
  actionCancel: 'admin-action-cancel',
};
